//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardSectionProperties from '../../../components/Card/CardSectionProperties.vue'
import FilesGroupsContainer from '../../../components/File/FilesGroupsContainer'
import { formatTime } from '../../helpers.js'

export default {
  components: {
    CardSectionProperties
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    eventsProperties: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      eventsToShow: []
    }
  },
  watch: {
    record: {
      handler: function () {
        this.eventsToShow = this.record.bp.events.filter(event => this.record.bp.eventsToShow.includes(event.id))

        this.eventsToShow.forEach(event => {
          event.objectSrc = {}
          event.config = {}
          event.config.props = []

          Object.defineProperty(event.objectSrc, '_filesGroups', {
            value: new FilesGroupsContainer(),
            writable: true,
            enumerable: false,
            configurable: true
          })

          const formId = event.form.type
          const formContent = typeof form === 'string' ? {} : event.form.content

          let eventProperties = this.eventsProperties[event.form.contentType] || null
          if (eventProperties) {
            if (typeof eventProperties === 'function') {
              eventProperties = eventProperties()
            }

            Object.keys(eventProperties).forEach(propKey => {
              const property = eventProperties[propKey]

              const value = formContent[propKey]

              const uniqueKey = propKey + '_' + formId
              this.$set(event.objectSrc, uniqueKey, value)

              const prop = Object.assign({}, property)

              prop.key = uniqueKey
              prop.code = propKey
              prop.eventId = formId

              const name = property.label || property.name
              prop.name = name
              prop._nameUpperCase = name.toUpperCase()

              prop.editable = false

              event.config.props.push(prop)
            })
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getEventUser: function (event) {
      return event.fio || event.user
    },
    getEventTimeText: function (event) {
      return event.time ? formatTime(event.time) : ''
    }
  }
}

